export function mergeAria(...attrs: Array<Record<string, string | undefined>>) {
  return attrs.reduce((acc, cur) => ({ ...acc, ...cur }), {});
}

export function ariaLabel(label?: string) {
  return label ? { 'aria-label': label } : {};
}

export function ariaDescribedBy(id?: string) {
  return id ? { 'aria-describedby': id } : {};
}

export function announce(message: string) {
  const regionId = 'app-live-region';
  let region = document.getElementById(regionId);
  if (!region) {
    region = document.createElement('div');
    region.id = regionId;
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    region.style.position = 'absolute';
    region.style.opacity = '0';
    region.style.pointerEvents = 'none';
    document.body.appendChild(region);
  }
  region.textContent = '';
  window.requestAnimationFrame(() => {
    region!.textContent = message;
  });
}

export function speak(text: string, lang = 'en-US') {
  if (!('speechSynthesis' in window)) return;
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = lang;
  window.speechSynthesis.cancel();
  window.speechSynthesis.speak(utterance);
}
